export const RESET_PAGE = 'RESET_PAGE';
export const SET_PAGE_TITLE = 'SET_PAGE_TITLE';

export const setPageTitle = (title, options = {}) => ({
  type: SET_PAGE_TITLE,
  payload: { title, options },
});

export const resetPage = () => ({
  type: RESET_PAGE,
});
